import * as pdfjsLib from 'pdfjs-dist'
import { PDFJS_DOC_ASSETS } from './pdfjs'
import { useBase64 } from '@ezio/utils'

export const accept =
    'image/png,image/gif,image/jpeg,application/pdf,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'

const maxSize = 3000

export const convertUploadFile = async (file: File, onFile: (b64: string, filename?: string) => unknown): Promise<{ preview: string | null }> => {
    if (!file) return { preview: null }

    const fileType = file.type

    if (fileType.indexOf('image') > -1) {
        const { convertImageToB64 } = useBase64()
        const b64File = await convertImageToB64(file, maxSize)
        await onFile(b64File, file.name)
        return { preview: b64File }
    } else if (fileType.indexOf('pdf') > -1) {
        const pdfData = new Uint8Array(await file.arrayBuffer())
        const pdfDoc = await pdfjsLib.getDocument({ data: pdfData, ...PDFJS_DOC_ASSETS }).promise

        const pageNumbers = Array.from({ length: pdfDoc.numPages }, (_, i) => i + 1)

        let b64File: string = null
        for (const pageNum of pageNumbers) {
            const page = await pdfDoc.getPage(pageNum)
            const viewport = page.getViewport({ scale: 1 })

            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')!
            canvas.width = viewport.width
            canvas.height = viewport.height

            await page.render({ canvasContext: context, viewport }).promise

            b64File = canvas.toDataURL('image/png')

            await onFile(b64File)
        }

        return { preview: b64File }
    } else {
        const { convertFileToB64 } = useBase64()
        const b64File = await convertFileToB64(file)
        await onFile(b64File, file.name)
        return { preview: null }
    }
}
